module.exports = __webpack_public_path__ + "img/f2996ff.jpg";